<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Invoices</div>
    </div>
    <div class="action_btn">
      <button class="btn tertiary_button" (click)="addNewMiscellaneousInvoice()">
        <app-svg-icon [path]="'assets/icons/plus_icon.svg'" style="background: #0E4E96;"></app-svg-icon>
        Miscellaneous
      </button>
      <button class="btn primary_button" (click)="addNewDocumentInvoice()">
        <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
        New
      </button>

    </div>
  </div>
</header>
<div class="search_bar_action_btns">
  <div class="container">
    <div class="search_bar">
      <div class="search_container">
        <input
          type="text"
          name="search_table"
          id="search_table"
          [(ngModel)]="searchTerm"
          placeholder="Search by name or code"
          (focus)="focusSearch = true"
          (focusout)="focusSearch = false"
          (keyup)="handleTableSearch($event)"
        >
        <img src="assets/icons/search_icon.svg" class="search_icon">
      </div>
    </div>

    <div class="filter_btn">
      <button (click)="applyFilters()">
        <img src="assets/icons/filter.svg">
        Filters
      </button>
    </div>

    <div class="bulk_actions">
      @if (selectedItems.length > 0 || allTableRecordsSelected) {
        <div class="selection_count">
          <div class="count">
            <!--            {{
                          allTableRecordsSelected
                            ? tableStats.total
                            : selectedItems.length
                        }}-->
            selected
          </div>
        </div>
        <div class="actions">
          <button class="tick" (click)="bulkActionConfirmation('setActive')">Make Banks Active</button>
          <button class="close" (click)="bulkActionConfirmation('setInActive')">Make Banks Inactive</button>
        </div>
      }
    </div>
  </div>
</div>
<app-tos-table
  [showTableStats]="false"
  [tableMeta]="tableMeta"
  [tableMenuOptions]="menuOptions"
  [(dataListRequest)]="tableListRequest"
  [dataListResponse]="tableListData"
  [(selectedItems)]="selectedItems"
  (tosTableAction)="getTableList()"
  (rowActionTriggered)="handleRowAction($event)"
  (tableMenuOptionSelected)="handleOptionSelected($event)"
></app-tos-table>



